<template>
  <div class="number-bets">
    <div
      v-for="num in numbers"
      :key="num"
      class="number-wrapper"
    >
      <div
        :class="['number-box']"
        @click="handleClick(num, $event)"
      >
        <!-- Üstte toplam bahis (0'dan büyükse göster) -->
        <div
          v-if="localBets[num] > 0"
          class="bet-amount"
        >
          {{ formatAmount(localBets[num] || 0) }}
        </div>

        <!-- Sayı etiketi -->
        <img
  class="number-img"
  :src="getNumberImage(num)"
  :alt="num"
/>

        <!-- Kutudaki çipler -->
        <div class="chip-layer">
          <div
            v-for="(chip, i) in chips[num] || []"
            :key="i"
            class="chip"
            :style="chip.style"
          ></div>
        </div>
        <div v-if="overlayState" class="overlay" :class="overlayState">
  <img
    :src="overlayState === 'lock' ? lockImg : fastImg"
    alt="overlay"
    class="overlay-icon"
  />
</div>
      </div>
    </div>

    <div style="text-align: center; margin-top: 6px; font-weight: bold; color: #fff;">
      9X
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, nextTick, onMounted, computed } from 'vue'

import { useStore } from 'vuex'
import lockImg from '@/assets/img/lock.png'
import fastImg from '@/assets/img/fast.png'
import img0 from '@/assets/img/wingo/0.png'
import img1 from '@/assets/img/wingo/1.png'
import img2 from '@/assets/img/wingo/2.png'
import img3 from '@/assets/img/wingo/3.png'
import img4 from '@/assets/img/wingo/4.png'
import img5 from '@/assets/img/wingo/5.png'
import img6 from '@/assets/img/wingo/6.png'
import img7 from '@/assets/img/wingo/7.png'
import img8 from '@/assets/img/wingo/8.png'
import img9 from '@/assets/img/wingo/9.png'
import { useToast } from 'vue-toastification'

import chipImg from '@/assets/img/chip-rivo.png'
import chipSound from '@/assets/sounds/chip.wav'

const store = useStore()
const toast = useToast()
const countdown = ref(30)

const overlayState = computed(() => {
  if (countdown.value <= 5) return 'lock'
  if (countdown.value <= 10) return 'fast'
  return null
})

const props = defineProps({
  selected: Number,
  bets: Object,
  roundId: String,
  user: Object,
  socket: Object
})

const emit = defineEmits(['select'])

const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0]
const chips = reactive({})
const localBets = reactive({})
const liveRoundId = ref(null)

onMounted(() => {
  const amountInput = document.querySelector('.amount-input input')

  // ✅ Round başladığında temizle
  let timerInterval = null

  props.socket?.on('wingo:round:start', ({ roundId }) => {
  liveRoundId.value = roundId

  countdown.value = 30
  clearInterval(timerInterval)
  timerInterval = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) clearInterval(timerInterval)
  }, 1000)

  nextTick(() => {
    Object.keys(chips).forEach(k => chips[k] = [])
    Object.keys(localBets).forEach(k => localBets[k] = 0)
  })
})

  // ✅ Bahis başarılıysa bakiye güncelle
  props.socket?.on('wingo:bet:success', () => {
    store.dispatch('authGetUser')
  })

  // ✅ Round sonucu gelince çipleri temizle
  props.socket?.on('wingo:round:result', () => {
    Object.keys(chips).forEach(k => chips[k] = [])
    Object.keys(localBets).forEach(k => localBets[k] = 0)
  })

  // ✅ Geçmiş çipleri yükle (yenileme veya geç katılım)
  props.socket?.emit('wingo:bet:sync:request')

props.socket?.on('wingo:bet:sync', ({ roundId, bets }) => {
  if (liveRoundId.value !== roundId) return

  for (const bet of bets) {
    const key = parseInt(bet.choice)
    if (!chips[key]) chips[key] = []

    const identifier = `${bet.userId}-${bet.choice}-${bet.amount}-${roundId}`
    const alreadyExists = chips[key].some(c => c?.id === identifier)

    if (!alreadyExists) {
      chips[key].push({
        style: generateChipStyle(),
        id: identifier
      })

      if (!localBets[key]) localBets[key] = 0
      localBets[key] += bet.amount
    }
  }
})



  // ✅ Yeni bahis geldiğinde çip ekle
props.socket?.on('wingo:bet:new', ({ userId, bets }) => {
  const myUserId = props.user?._id

  // ✅ Socket'tan gelen kullanıcı bizsek animasyonu ve sesi tekrar etme
  if (!userId || !myUserId || userId === myUserId) return

  for (const bet of bets) {
    const key = parseInt(bet.choice)
    if (!chips[key]) chips[key] = []

    const identifier = `${userId}-${bet.choice}-${bet.amount}-${liveRoundId.value}`
    const alreadyExists = chips[key].some(c => c?.id === identifier)

    if (!alreadyExists) {
      chips[key].push({
        style: generateChipStyle(),
        id: identifier
      })

      if (!localBets[key]) localBets[key] = 0
      localBets[key] += bet.amount

      const box = document.querySelector(`.number-wrapper:nth-child(${numbers.indexOf(key) + 1}) .number-box`)
      if (box) animateFlyingChip(key, { currentTarget: box })
    }
  }
})


})

const getNumberImage = (num) => numberImages[num]

const numberImages = {
  0: img0, 1: img1, 2: img2, 3: img3, 4: img4,
  5: img5, 6: img6, 7: img7, 8: img8, 9: img9
}

const handleClick = (num, event) => {
  // 🔒 Login kontrol
  if (!props.user || !props.user._id) {
    store.dispatch('modalsSetShow', 'Login')
    return
  }

  // ⏳ Zaman kontrol
  if (countdown.value <= 5) {
    console.warn('[BET] Süre dolmak üzere, bahis engellendi')
    return
  }

  emit('select', num)

  const amountInput = document.querySelector('.amount-input input')
  const amount = parseFloat(amountInput?.value || '0')
  if (amount <= 0) return

  const currency = props.user?.currency
  const rawWallet = props.user?.wallets?.find(w =>
    w.coinType === currency?.coinType &&
    w.chain === currency?.chain &&
    w.type === currency?.type
  )

  // 💸 Yetersiz bakiye kontrolü
const balance = rawWallet?.balance || 0
if (amount > balance) {
  store.dispatch('notificationShow', {
    type: 'error',
    message: 'Yetersiz bakiye. Lütfen cüzdanınıza bakiye yükleyin.'
  })
  return
}

  // ✅ Bu noktadan sonrası güvenli
  if (!localBets[num]) localBets[num] = 0
  localBets[num] += amount

  animateFlyingChip(num, event)

  if (!chips[num]) chips[num] = []
  chips[num].push({
    style: generateChipStyle()
  })

  const token = localStorage.getItem('token')
  if (!token || !rawWallet || !props.socket || !liveRoundId.value || !currency?.fiatCurrency) {
    console.warn('[BET] Eksik bilgi')
    return
  }

  const cleanWallet = {
    coinType: rawWallet.coinType,
    chain: rawWallet.chain,
    type: rawWallet.type,
    currency: currency.fiatCurrency
  }

  const betPayload = {
    token,
    bets: [{
      roundId: liveRoundId.value,
      betType: 'number',
      choice: num.toString(),
      amount,
      wallet: cleanWallet
    }]
  }

  props.socket.emit('wingo:bet', betPayload)
}


const playChipSound = () => {
  const audio = new Audio(chipSound)
  audio.volume = 0.4
  audio.play().catch(() => {})
}

const animateFlyingChip = async (num, event) => {
  const amountBox = document.querySelector('.amount-input input')
  const targetBox = event.currentTarget
  if (!amountBox || !targetBox) return

  playChipSound()

  const startRect = amountBox.getBoundingClientRect()
  const endRect = targetBox.getBoundingClientRect()

  const chipEl = document.createElement('div')
  chipEl.className = 'flying-chip'
  chipEl.style.backgroundImage = `url(${chipImg})`
  chipEl.style.position = 'fixed'
  chipEl.style.top = `${startRect.top + startRect.height / 2 + window.scrollY}px`
  chipEl.style.left = `${startRect.left + startRect.width / 2 + window.scrollX}px`
  chipEl.style.width = '26px'
  chipEl.style.height = '26px'
  chipEl.style.backgroundSize = 'contain'
  chipEl.style.backgroundRepeat = 'no-repeat'
  chipEl.style.backgroundPosition = 'center'
  chipEl.style.opacity = '0'
  chipEl.style.transition = 'transform 0.6s ease, opacity 0.6s ease'
  chipEl.style.zIndex = '99999'
  chipEl.style.pointerEvents = 'none'

  document.body.appendChild(chipEl)

  await nextTick()

  requestAnimationFrame(() => {
    const deltaX = (endRect.left + endRect.width / 2) - (startRect.left + startRect.width / 2)
    const deltaY = (endRect.top + endRect.height / 2) - (startRect.top + startRect.height / 2)
    chipEl.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.6)`
    chipEl.style.opacity = '1'
  })

  setTimeout(() => {
    document.body.removeChild(chipEl)
  }, 600)
}

const generateChipStyle = () => ({
  top: `${Math.random() * 60 + 10}%`,
  left: `${Math.random() * 60 + 10}%`,
  backgroundImage: `url(${chipImg})`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  width: '26px',
  height: '26px',
  position: 'absolute',
  zIndex: '2'
})

const formatAmount = (val) => {
  if (val >= 1000) return (val / 1000).toFixed(1) + 'k'
  return val.toFixed(0)
}
</script>




<style scoped>
.number-bets {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.85rem;
 
  position: relative;
}

.number-wrapper {
  position: relative;
  width: calc(20% - 0.75rem);
  height: 70px;
  box-sizing: border-box;
}

.number-box {
      background:var(--background);
  border-radius: 12px;
  padding: 1px;
  height: 70px;
  text-align: center;
  cursor: pointer;
  
  transition: all 0.2s ease;
  position: relative;
  box-sizing: border-box;
  overflow: visible;
  z-index: 1;
}

.number-box::before {
       content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    padding: 1px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #e0d601 100%);
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
}

.bet-amount {
  position: absolute;
  top: -10px;
  right: -10px;
  background: var(--background);
  color: #fff;
  padding: 3px 6px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 6px;
  z-index: 3;
}



.number {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  position: relative;
  z-index: 2;
  background: var(--background);
  border-radius: 8px;
  padding: 4px 8px;
  margin: 4px auto 0;
  display: inline-block;
}

.number-img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 32px;
  height: auto;
  transform: translate(-50%, -50%);
  z-index: 2;
  pointer-events: none;
}

.chip-layer {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 1;
}

.chip {
  position: absolute;
  z-index: 2;
}

.flying-chip {
  position: fixed;
  top: 0;
  left: 0;
  width: 26px;
  height: 26px;
  background-image: url('@/assets/img/chip-rivo.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.6s ease, opacity 0.6s ease;
  z-index: 99999;
  pointer-events: none;
  opacity: 0;
}

.overlay {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.overlay.fast {
  background-color: rgba(0, 0, 0, 0.445);
}

.overlay.lock {
  background-color: rgba(0, 0, 0, 0.589);
}

.overlay-icon {
  width: 32px;
  height: 32px;
  opacity: 0.8;
}
</style>
